export enum BreakpointWidthPx {
  Small = 800,
  Medium = 1100,
  Large = 1280,
  XLarge = 2000,
}
